<template>
  <div>
    <form id="form" ref="form" :action="targetUrl" :method="method" style="display:none" target="_blank">
      <input :value="token" name="token" >
      <div v-if="paramMode === 'field'">
        <input v-for="(value, key) in params" :key="key" :value="value" :name="key" type="text" >
      </div>
      <div>{{ paramMode }}</div>
    </form>
  </div>
</template>
<script>
import { tokenUtils } from '@/utils/auth'
export default {
  name: 'VForm',
  props: {
    params: {
      type: Object,
      default: () => {
        return {}
      }
    },
    method: {
      type: String,
      default: 'post'
    },
    paramMode: {
      type: String,
      default: 'url'
    },
    withToken: {
      type: Boolean,
      default: true
    },
    url: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      token: ''
    }
  },
  computed: {
    targetUrl () {
      let targetUrl = this.url
      if (this.paramMode === 'url' && this.params) {
        const paramArray = []
        for (const key in this.params) {
          if (this.params[key] || this.params[key] === 0) {
            let curValue = this.params[key]
            paramArray.push(key + '=' + encodeURIComponent(curValue))
          }
        }
        if (paramArray.length > 0) {
          targetUrl += '?' + paramArray.join('&')
        }
      }
      return targetUrl
    }
  },
  methods: {
    submit () {
      if (this.withToken) {
        this.token = tokenUtils.getToken(true)
      }
      this.$nextTick(() => {
        this.$refs.form.submit()
      })
    }
  }
}
</script>
